import { zfTranslations } from "./zf_translations";
import { zfUtils, zfcsr } from "./zf_utils";
import { zfc } from "./zfc_global";
import { zfcpc } from "./zfc_press";
import { zfctt } from "./zfc_teaser_tile";
import { zfccg } from "./zfc_content_group";
import { Swiper, Navigation, A11y } from "./swiper-config";
import * as AwesompleteModule from "awesomplete";
const AwesompleteClass = AwesompleteModule.default || AwesompleteModule;
export class zfcsaf {
    static hasTargets() {
        return $(".zfcsaf-search-filter-wrapper").length > 0;
    }
    static isPastDate(dateValue) {
        const parsed = Date.parse(dateValue);
        return !Number.isNaN(parsed) && parsed < Date.now();
    }
    static addDaysToIsoUtc(days) {
        const date = new Date();
        date.setDate(date.getDate() + Number(days));
        return date.toISOString().substring(0, 19) + "Z";
    }
    static findMainControl(control) {
        return $(control).closest(".zfcsaf-search-filter-wrapper");
    }
    static findMainId(control) {
        return zfcsaf.findMainControl(control).attr("id");
    }
    static findSearchObject(id) {
        return $("#" + id);
    }
    static findSearchControl(id) {
        return $(zfcsaf
            .findSearchObject(id)
            .find('.zfccf-certificate-form-input input[type="text"]'));
    }
    static openModal(caller, parent_id, caller_id) {
        var that = $(caller);
        var modalParent = that.closest(".handlebar_search_results");
        var modalTemplate = zfUtils.handlebarsCompile($(".handlbar_zfcec-modal").html());
        var resultHTML = "";
        var currItem = caller_id
            ? zfcsaf.controls[parent_id].jsonData[caller_id]
            : {};
        currItem.meta = zfcsaf.translations;
        resultHTML = zfUtils.handlebarsProcessTemplate(modalTemplate, currItem);
        modalParent.find(".zfcec-modal-wrapper-content").html(resultHTML);
        modalParent.find(".zfcec-modal-wrapper-background").css("display", "block");
        modalParent
            .find(".zfcec-modal-wrapper-content")
            .find(".zfcec-modal")
            .show();
    }
    static closeModal(caller, index) {
        var that = $(caller);
        var modalParent = that.closest(".handlebar_search_results");
        that.closest(".zfcec-modal").slideUp();
        setTimeout(function () {
            modalParent
                .find(".zfcec-modal-wrapper-background")
                .css("display", "none");
            that.closest(".zfcec-modal-wrapper-content").html("");
        }, 300);
    }
    static updateActiveCategoryCount(searchObject) {
        $(searchObject).find(".zfcsaf-filter-list-wrapper").each(function () {
            var count = $(this).find('.zfcsaf-filter-list-items input[type="checkbox"]:checked').length;
            if (count > 0 && ($(this).find(".zfcsaf-active-filter-count span").text() != count.toString())) {
                $(this).find(".zfcsaf-active-filter-count span").text(count);
                $(this).find(".zfcsaf-active-filter-count").css("display", "inline-block");
            }
            else {
                $(this).find(".zfcsaf-active-filter-count").hide();
            }
        });
    }
    static toggleSort(id) {
        var that = $(this);
        that.siblings(".zfcui-btn").removeClass("zfcsaf-sort-active");
        that.addClass("zfcsaf-sort-active");
        if (zfcsaf.controls[id].activeSort == that.data("value") &&
            zfcsaf.controls[id].sortOrder == "asc")
            zfcsaf.controls[id].sortOrder = "desc";
        else
            zfcsaf.controls[id].sortOrder = "asc";
        zfcsaf.controls[id].activeSort = that.data("value");
        zfcsaf.controls[id].sortField = that.data("value");
        zfcsaf.renderResults(id);
    }
    static filterDropdownOpen(that, main) {
        if ($('#' + main).hasClass("zfcsaf-legacy")) {
            that.addClass("zfcsaf-filter-list-toggled");
            that
                .siblings(".zfcsaf-filter-list-items")
                .children(".zfcsaf-filter-list-items-wrap")
                .slideDown();
            that.attr("aria-expanded", "true");
        }
        else {
            that.siblings(".zfcsaf-filter-list-items").removeAttr('style');
            var currHeight = that.siblings(".zfcsaf-filter-list-items").height();
            that.siblings(".zfcsaf-filter-list-items").show().css({
                'display': 'block',
                'height': 0,
                'opacity': 0
            }).animate({
                height: currHeight <= 400 ? currHeight : 400,
                opacity: 1
            }, {
                duration: 200
            });
            that.addClass('zfcsaf-filter-list-toggled').attr("aria-expanded", "true");
        }
    }
    static filterDropdownClose(that, main) {
        if ($('#' + main).hasClass("zfcsaf-legacy")) {
            that.removeClass("zfcsaf-filter-list-toggled");
            that
                .siblings(".zfcsaf-filter-list-items")
                .children(".zfcsaf-filter-list-items-wrap")
                .slideUp();
            that.find("button").attr("aria-expanded", "false");
        }
        else {
            that.siblings(".zfcsaf-filter-list-items").fadeOut(200);
            that.removeClass('zfcsaf-filter-list-toggled').attr("aria-expanded", "false");
        }
    }
    static toggleDropdown(e) {
        e.stopPropagation();
        var id = zfcsaf.findMainId(this);
        var fieldName = $(this)
            .closest(".zfcsaf-filter-list-wrapper")
            .data("field");
        var that = $(this).closest(".zfcsaf-filter-list").find(".zfcsaf-filter-list-label");
        if (that.hasClass("zfcsaf-filter-list-toggled")) {
            zfcsaf.filterDropdownClose(that, id);
        }
        else {
            var searchObject = zfcsaf.findMainControl(that);
            if (searchObject.find(".zfcsaf-filter-list-toggled").length)
                zfcsaf.filterDropdownClose(that.closest(".zfcsaf-more-filter-container").find(".zfcsaf-filter-list-label.zfcsaf-filter-list-toggled"), id);
            if (searchObject
                .find(".zfcsaf-last-updated")
                .nextAll('.zfcsaf-filter-list-wrapper[data-field="' + fieldName + '"]').length) {
                zfcsaf.updateFilters(id);
                zfcsaf.getFacetData(id, fieldName, function () {
                    var that = $("#" + id + " .zfcsaf-filter-list-wrapper[data-field=" + fieldName + "] .zfcsaf-filter-list-label");
                    zfcsaf.filterDropdownOpen(that, id);
                });
            }
            else {
                zfcsaf.filterDropdownOpen(that, id);
            }
        }
    }
    static updateChecklists(id, fieldName) {
        var searchObject = zfcsaf.findSearchObject(id);
        var checkListTemplate = zfUtils.handlebarsCompile(searchObject.find(".handlbar_zfcsaf-filter-list-items").html());
        var checkListDestination = searchObject.find(".handlebar_zfcsaf-filter-list-wrapper");
        var matchesFieldName = false;
        (zfcsaf.controls[id].fields || []).forEach(function (field) {
            if (fieldName == field.id || matchesFieldName) {
                if (fieldName == field.id)
                    matchesFieldName = true;
                if (zfcsaf.controls[id].facets.hasOwnProperty(field.id) &&
                    Object.keys(zfcsaf.controls[id].facets[field.id].buckets).length >
                        1 &&
                    (!field.hasOwnProperty("display") || field.display == "true")) {
                    if (zfcsaf.controls[id].filters.hasOwnProperty(field.label)) {
                        zfcsaf.controls[id].facets[field.id].buckets.forEach(function (bucket, index) {
                            if (zfcsaf.controls[id].filters[field.label].hasOwnProperty(bucket.value))
                                zfcsaf.controls[id].facets[field.id].buckets[index]["active"] =
                                    true;
                        });
                    }
                    checkListDestination
                        .find('.zfcsaf-filter-list-wrapper[data-field="' + field.id + '"]')
                        .remove();
                    zfcsaf.controls[id].facets[field.id].buckets.forEach(function (bucket, index) {
                        var bucketLabel = "";
                        var bucketArr;
                        if (bucket.hasOwnProperty("label"))
                            bucketLabel = bucket.label;
                        else
                            bucketLabel = bucket.value;
                        if (zfTranslations.get(bucketLabel) != "")
                            bucketLabel = zfTranslations.get(bucketLabel);
                        else {
                            if (field.id == "content_type" &&
                                (bucket.value == "All" || bucket.value == "html")) {
                                bucketArr = bucketLabel.toLowerCase().split(" ");
                                bucketArr.forEach(function (s, i) {
                                    bucketArr[i] =
                                        s.charAt(0).toUpperCase() +
                                            (s.length > 1 ? s.substring(1) : "");
                                });
                                bucketLabel = bucketArr.join(" ");
                            }
                            if (bucketLabel.indexOf(" ") >= 0 || field.id != "content_type") {
                                bucketArr = bucketLabel.toLowerCase().split(" ");
                                bucketArr.forEach(function (s, i) {
                                    bucketArr[i] =
                                        s.charAt(0).toUpperCase() +
                                            (s.length > 1 ? s.substring(1) : "");
                                });
                                bucketLabel = bucketArr.join(" ");
                            }
                            if (bucketLabel.indexOf("-") >= 0) {
                                bucketArr = bucketLabel.split("-");
                                bucketArr.forEach(function (s, i) {
                                    bucketArr[i] =
                                        s.charAt(0).toUpperCase() +
                                            (s.length > 1 ? s.substring(1) : "");
                                });
                                bucketLabel = bucketArr.join("-");
                            }
                            if (bucketLabel.indexOf("(") >= 0) {
                                bucketArr = bucketLabel.split("(");
                                bucketArr.forEach(function (s, i) {
                                    bucketArr[i] =
                                        s.charAt(0).toUpperCase() +
                                            (s.length > 1 ? s.substring(1) : "");
                                });
                                bucketLabel = bucketArr.join("(");
                            }
                            bucketLabel = bucketLabel
                                .replace(/Zf/g, "ZF")
                                .replace(/Lcv/g, "LCV")
                                .replace(/And/g, "and")
                                .replace(/Und/g, "und")
                                .replace(/(dmu)/g, "(DMU)")
                                .replace(/(emu)/g, "(EMU)")
                                .replace(/(mpv)/g, "(MPV)")
                                .replace(/Rs/g, "RS")
                                .replace(/Hmi/g, "HMI");
                            var parenMatch = bucketLabel.match("\\(\\D\\D\\D\\)");
                            if (parenMatch != null && parenMatch[0].length > 0) {
                                bucketLabel = bucketLabel.replace(new RegExp(parenMatch[0]), parenMatch[0].toUpperCase());
                            }
                        }
                        zfcsaf.controls[id].facets[field.id].buckets[index]["label"] =
                            bucketLabel;
                    });
                    var resultHTML = zfUtils.handlebarsProcessTemplate(checkListTemplate, {
                        label: zfTranslations.get(field.label),
                        labelid: field.label,
                        field: field.id,
                        class: field.class,
                        buckets: zfcsaf.controls[id].facets[field.id].buckets,
                    });
                    checkListDestination.append(resultHTML);
                    var currChecklist = checkListDestination.find('.zfcsaf-filter-list-wrapper[data-field="' + field.id + '"]');
                    currChecklist.find(".zfcsaf-replaced-label").show();
                    currChecklist.find(".zfcsaf-default-label").hide();
                    currChecklist
                        .find(".zfcsaf-filter-list-label")
                        .off("click.zfcsaf")
                        .on("click.zfcsaf", zfcsaf.toggleDropdown);
                    currChecklist
                        .find(".zfcsaf-filter-close-mobile")
                        .off("click.zfcsaf")
                        .on("click.zfcsaf", zfcsaf.toggleDropdown);
                    zfcsaf.updateActiveCategoryCount(searchObject);
                    if (!searchObject.find(".zfcsaf-more-filter-container").hasClass("zfcsaf-filter-auto-toggle")) {
                        searchObject
                            .off("click.zfcsafAutoToggle")
                            .on("click.zfcsafAutoToggle", function (e) {
                            var activeBtn = searchObject.find(".zfcsaf-filter-list-toggled");
                            var activeDropdown = activeBtn.closest(".zfcsaf-filter-list").find(".zfcsaf-filter-list-items");
                            if (activeBtn.length > 0 && (!activeBtn.is(e.target) && activeDropdown.has(e.target).length === 0)) {
                                zfcsaf.filterDropdownClose(activeBtn, searchObject.attr("id"));
                            }
                        });
                        searchObject.find(".zfcsaf-more-filter-container").addClass("zfcsaf-filter-auto-toggle");
                    }
                    currChecklist
                        .find("input[data-value!=" + zfTranslations.get("all") + "]")
                        .siblings(["label"])
                        .off("click.zfcsaf")
                        .on("click.zfcsaf", function () {
                        var checkListControl = $(this).closest(".zfcsaf-filter-list-wrapper");
                        checkListControl
                            .find('input[data-value="' + zfTranslations.get("all") + '"]')
                            .prop("checked", false);
                        $(this).siblings("input").prop("checked")
                            ? $(this).siblings("input").prop("checked", false)
                            : $(this).siblings("input").prop("checked", true);
                        zfcsaf.updateActiveCategoryCount(searchObject);
                        searchObject
                            .find(".zfcsaf-last-updated")
                            .removeClass("zfcsaf-last-updated");
                        currChecklist.addClass("zfcsaf-last-updated");
                        var matchesFieldName = false;
                        (zfcsaf.controls[id].fields || []).forEach(function (field) {
                            if (zfcsaf.controls[id].facets.hasOwnProperty(field.id)) {
                                if (matchesFieldName) {
                                    searchObject
                                        .find('.zfcsaf-filter-list-wrapper[data-field="' +
                                        field.id +
                                        '"] input[type=checkbox]:checked')
                                        .prop("checked", false);
                                }
                                if (checkListControl.data("field") == field.id) {
                                    matchesFieldName = true;
                                }
                            }
                        });
                        zfcsaf.updateBtnClickHandler(id);
                    });
                    currChecklist
                        .find("input[data-value=" + zfTranslations.get("all") + "]")
                        .siblings(["label"])
                        .off("click.zfcsaf")
                        .on("click.zfcsaf", function () {
                        var checkListControl = $(this).closest(".zfcsaf-filter-list-wrapper");
                        checkListControl.find("input[type=checkbox]").prop("checked", false);
                        checkListControl
                            .find('input[data-value="' + zfTranslations.get("all") + '"]')
                            .prop("checked", true);
                        zfcsaf.updateActiveCategoryCount(searchObject);
                        zfcsaf.updateBtnClickHandler(id);
                    });
                    var resetCategory = currChecklist.find(".zfcsaf-filter-list-reset-category");
                    zfc.keyboardEnterToClick(resetCategory);
                    resetCategory
                        .off("click.zfcsaf")
                        .on("click.zfcsaf", function () {
                        var wrap = resetCategory.closest(".zfcsaf-filter-list-items-wrap");
                        if (wrap.find("input[type=checkbox]:checked").length > 0) {
                            wrap.find("input[type=checkbox]:checked").prop("checked", false);
                            resetCategory
                                .closest(".zfcsaf-filter-list")
                                .find(".zfcsaf-filter-list-label .zfcsaf-active-filter-count span")
                                .text("0");
                            resetCategory
                                .closest(".zfcsaf-filter-list")
                                .find(".zfcsaf-filter-list-label .zfcsaf-active-filter-count")
                                .hide();
                            zfcsaf.updateBtnClickHandler(id);
                        }
                    });
                }
            }
        });
    }
    static updateFilters(id) {
        var searchObject = zfcsaf.findSearchObject(id);
        searchObject.find(".zfcsaf-filter-list-wrapper").each(function () {
            var filter = $(this);
            zfcsaf.controls[id].filters[filter.data("label")] = {};
            filter.find("input[type=checkbox]").each(function () {
                var checkInput = $(this);
                var value = checkInput.data("value");
                if (value != zfTranslations.get("all"))
                    checkInput.prop("checked") == true
                        ? (zfcsaf.controls[id].filters[filter.data("label")][value] = value)
                        : delete zfcsaf.controls[id].filters[filter.data("label")][value];
            });
        });
    }
    static updateBtnClickHandler(id) {
        zfcsaf.controls[id].startPos = 0;
        zfcsaf.updateFilters(id);
        zfcsaf.activeFiltersDisplay(id);
        zfcsaf.search(id);
        zfcsaf.updateUrlParameters(id);
    }
    static prepareControls(id) {
        var searchObject = zfcsaf.findSearchObject(id);
        zfc.keyboardEnterToClick(searchObject.find(".zfcsaf-more-filter-toggle-button"));
        searchObject
            .find(".zfcsaf-more-filter-toggle-button")
            .off("click.zfcsaf")
            .on("click.zfcsaf", function () {
            searchObject.find(".zfcsaf-column-left").slideToggle();
            if (searchObject
                .find(".zfcsaf-more-filter-toggle")
                .hasClass("zfcsaf-toggled")) {
                searchObject
                    .find(".zfcsaf-more-filter-toggle")
                    .removeClass("zfcsaf-toggled");
                searchObject.find(".zfcsaf-more-filter-toggle-label-close").show();
                searchObject.find(".zfcsaf-more-filter-toggle-label-open").hide();
            }
            else {
                searchObject
                    .find(".zfcsaf-more-filter-toggle")
                    .addClass("zfcsaf-toggled");
                searchObject.find(".zfcsaf-more-filter-toggle-label-close").hide();
                searchObject.find(".zfcsaf-more-filter-toggle-label-open").show();
            }
        });
        var hasSortBtn = false;
        if (!hasSortBtn && searchObject.data("hide-filters") == "yes")
            searchObject.find(".zfcsaf-column-left").hide();
        if (searchObject.data("hide-search") == "yes")
            searchObject
                .find(".zfccf-search-tool-search-row")
                .closest(".zfcsw-wrapper")
                .hide();
        if (searchObject.find(".handlebar_sortBtns_wrapper").html() == "")
            searchObject.find(".zfcsaf-visible-filter-label").hide();
        searchObject.find(".zfcsaf-more-filter-separator").hide();
        searchObject
            .off("click", ".zfsf-sort-btn")
            .on("click", ".zfsf-sort-btn", zfcsaf.toggleSort);
        searchObject
            .off("click", ".zfcsaf-trigger-filter")
            .on("click", ".zfcsaf-trigger-filter", function () {
            $(this).toggleClass("open-filter");
            searchObject.find(".zfcsaf-more-filter-container").slideToggle();
        });
        searchObject
            .off("click", ".zfccf-certificate-form-input button")
            .on("click", ".zfccf-certificate-form-input button", zfcsaf.handleSearchClick);
        searchObject
            .off("keypress", '.zfccf-certificate-form-input input[type="text"]')
            .on("keypress", '.zfccf-certificate-form-input input[type="text"]', zfcsaf.handleSearchKey);
        searchObject
            .off("focus.zfcsafSearch click.zfcsafSearch", '.zfccf-certificate-form-input input[type="text"]')
            .on("focus.zfcsafSearch click.zfcsafSearch", '.zfccf-certificate-form-input input[type="text"]', function () {
            var id = zfcsaf.findMainId(this);
            var autocompleteKey = "zfcsaf-datalist-" + id;
            var autocomplete = zfcsaf.autocompleteInstances[autocompleteKey];
            if (autocomplete && typeof autocomplete.evaluate === "function") {
                autocomplete.evaluate();
            }
            $(autocomplete.input)
                .off("awesomplete-selectcomplete")
                .on("awesomplete-selectcomplete", zfcsaf.handleAutocompleteSelected);
        });
    }
    static handleSearchClick(event) {
        var searchObject = zfcsaf.findMainControl(event.target);
        var id = searchObject.attr("id");
        zfcsaf.controls[id].startPos = 0;
        zfcsaf.search(id);
        zfcsaf.updateUrlParameters(id);
    }
    static handleSearchKey(event) {
        var searchObject = zfcsaf.findMainControl(event.target);
        var id = searchObject.attr("id");
        if (event.which == 13 && !event.shiftKey) {
            zfcsaf.controls[id].startPos = 0;
            zfcsaf.search(id);
            zfcsaf.updateUrlParameters(id);
        }
        else {
            var nextValue = event.currentTarget.value + (event.key || "");
            zfcsaf.scheduleAutocomplete(searchObject.data("scope"), "zfcsaf-datalist-" + id, nextValue, 15);
        }
    }
    static handleAutocompleteSelected(event) {
        event = event.originalEvent.originalEvent;
        if (event.which == 13 && !event.shiftKey) {
            zfcsaf.handleSearchKey(event);
        }
        else {
            zfcsaf.handleSearchClick(event);
        }
    }
    static registerAutocompleteInput(autocompleteKey, inputElement) {
        if (!autocompleteKey || !inputElement || zfcsaf.autocompleteInstances[autocompleteKey])
            return;
        zfcsaf.autocompleteInputs[autocompleteKey] = inputElement;
        inputElement.setAttribute("autocomplete", "off");
        inputElement.removeAttribute("list");
        if (zfcsaf.autocompleteInstances[autocompleteKey] &&
            zfcsaf.autocompleteInstances[autocompleteKey].input === inputElement)
            return;
        zfcsaf.autocompleteInstances[autocompleteKey] = new AwesompleteClass(inputElement, {
            minChars: 0,
            maxItems: 15,
            autoFirst: false,
            sort: false,
        });
    }
    static clearAutocomplete(autocompleteKey) {
        var autocomplete = zfcsaf.autocompleteInstances[autocompleteKey];
        if (autocomplete) {
            autocomplete.list = [];
            if (typeof autocomplete.close === "function")
                autocomplete.close();
        }
    }
    static scheduleAutocomplete(scope, autocompleteKey, value, resultCount, initialQuery = false) {
        var query = (value || "").trim();
        if (zfcsaf.autocompleteDebounceTimers[autocompleteKey]) {
            clearTimeout(zfcsaf.autocompleteDebounceTimers[autocompleteKey]);
        }
        zfcsaf.autocompleteRequestVersion[autocompleteKey] =
            (zfcsaf.autocompleteRequestVersion[autocompleteKey] || 0) + 1;
        var requestVersion = zfcsaf.autocompleteRequestVersion[autocompleteKey];
        var shouldOpenDropdown = !initialQuery;
        zfcsaf.autocompleteDebounceTimers[autocompleteKey] = setTimeout(function () {
            zfcsaf.autocomplete(scope, autocompleteKey, query, resultCount, requestVersion, shouldOpenDropdown);
        }, zfcsaf.autocompleteDebounceMs);
        var autocomplete = zfcsaf.autocompleteInstances[autocompleteKey];
        if (!$(autocomplete.input).hasClass("zfcsaf-awesomplete-check-empty")) {
            $(autocomplete.input).on('input', function (e) {
                var input = this;
                if ($(input).val().length === 0) {
                    zfcsaf.autocomplete(scope, autocompleteKey, query, resultCount, zfcsaf.autocompleteRequestVersion[autocompleteKey], shouldOpenDropdown);
                }
                ;
            });
            $(autocomplete.input).addClass("zfcsaf-awesomplete-check-empty");
        }
    }
    static activeFiltersDisplay(id) {
        var searchObject = zfcsaf.findSearchObject(id);
        var wrapper = searchObject.find(".zfcsaf-more-filter-container");
        var activeFilters = {};
        if (wrapper.find(".zfcsaf-filter-list-wrapper input[type=checkbox]:checked")
            .length > 0) {
            var checked = wrapper.find(".zfcsaf-filter-list-wrapper input[type=checkbox]:checked");
            activeFilters.data = checked;
            const template = zfUtils.handlebarsCompile(searchObject.find(".handlebar_search_active_filters").html());
            var resultHTML = zfUtils.handlebarsProcessTemplate(template, activeFilters);
            searchObject.find(".zfcsaf-active-filters-container").html(resultHTML);
            searchObject.find(".zfcsaf-active-filter-element-label").each(function () {
                zfc.keyboardEnterToClick($(this));
            });
            searchObject
                .off("click", ".zfcsaf-active-filter-element:not(.zfcsaf-button-reset) > .zfcsaf-active-filter-element-label")
                .on("click", ".zfcsaf-active-filter-element:not(.zfcsaf-button-reset) > .zfcsaf-active-filter-element-label", function (e) {
                e.preventDefault();
                var that = $(this);
                var value = that
                    .closest(".zfcsaf-active-filter-element")
                    .find("input")
                    .data("value");
                searchObject
                    .find('.zfcsaf-filter-list-items-wrap input[value="' + value + '"]')
                    .prop("checked", false);
                zfcsaf.updateBtnClickHandler(id);
                zfcsaf.updateActiveCategoryCount(searchObject);
            });
            zfc.keyboardEnterToClick(searchObject.find(".zfcsaf-button-reset"));
            searchObject
                .off("click", ".zfcsaf-button-reset")
                .on("click", ".zfcsaf-button-reset", function () {
                searchObject
                    .find(".zfcsaf-filter-list-items-wrap input[type=checkbox]:checked")
                    .prop("checked", false);
                searchObject.find(".zfcsaf-active-filter-count span").text("0");
                searchObject.find(".zfcsaf-active-filter-count").hide();
                zfcsaf.findSearchControl(id).val("");
                zfcsaf.updateBtnClickHandler(id);
            });
        }
        else {
            searchObject.find(".zfcsaf-active-filters-container").html("");
        }
    }
    static checkPaginationIncluded(array, key, value) {
        let exists = false;
        $.each(array, function (index, obj) {
            if (obj.hasOwnProperty(key) && obj[key] === value) {
                exists = true;
                return false;
            }
        });
        return exists;
    }
    static renderResults(id, filterType, filterValue) {
        var searchObject = zfcsaf.findSearchObject(id);
        var limit = searchObject.data("limit");
        var shown = searchObject.data("shown");
        var searchResultObject = searchObject.find(".zfcsl_search_result");
        if (filterType == null)
            filterType = zfcsaf.controls[id].fields;
        if (filterValue == null)
            filterValue = zfcsaf.controls[id].filters;
        var results = zfcsaf.controls[id].jsonData;
        var searchVal = zfcsaf.findSearchControl(id).val();
        if (searchVal != "") {
            if (searchObject.data("type") == "jobboard")
                results = zfUtils.filterByKey(results, "ANY", searchVal);
        }
        if (zfcsaf.controls[id].sortField != null &&
            zfcsaf.controls[id].sortOrder != null)
            if (zfcsaf.controls[id].sortField.indexOf(".") != -1)
                results = zfUtils.sortByKey(results, zfcsaf.controls[id].sortField.split(".")[0], zfcsaf.controls[id].sortOrder, zfcsaf.controls[id].sortField.split(".")[1]);
            else
                results = zfUtils.sortByKey(results, zfcsaf.controls[id].sortField, zfcsaf.controls[id].sortOrder);
        var myData = {};
        myData.data = results;
        myData.meta = zfcsaf.translations;
        const template = zfUtils.handlebarsCompile(searchObject.find(".handlebar_search_item").html());
        const resultHTML = zfUtils.handlebarsProcessTemplate(template, myData);
        searchResultObject.find(".zfcsl-paginator").html("");
        if (myData.data.length == 0) {
            searchObject.find(".zfcsaf-no-results-display").css("display", "inline");
        }
        else {
            searchObject.find(".zfcsaf-no-results-display").css("display", "none");
        }
        var jsonDataSize = zfcsaf.controls[id].jsonDataSize || myData.data.length;
        if (myData.data.length < jsonDataSize) {
            var useSwiper = searchResultObject
                .find(".zfcsl-paginator")
                .hasClass("swiper");
            $(".zfcsl_search_result").hasClass("zfcsl-empty-pagination")
                ? $(".zfcsl_search_result").removeClass("zfcsl-empty-pagination")
                : "";
            searchResultObject
                .find(".zfcsl_search_result_num span")
                .html(jsonDataSize);
            if (useSwiper == false) {
                searchResultObject
                    .find(".zfcsl-paginator")
                    .removeClass("slick-initialized");
                searchResultObject.find(".zfcsl-paginator").removeClass("slick-slider");
            }
            var currPage = zfcsaf.controls[id].startPos / searchObject.data("shown");
            var numPages = jsonDataSize / searchObject.data("shown");
            var paginations = [];
            searchResultObject.find(".zfcsl-paginator").html(function () {
                var paginatorHtml = useSwiper ? "<div class='swiper-wrapper'>" : "";
                for (let step = 0; step * shown <= jsonDataSize; step++) {
                    paginatorHtml =
                        paginatorHtml +
                            "<button class='zfcsl-paginator-item swiper-slide " +
                            (currPage == step ? "zfcsl-selected-item" : "") +
                            "' data-page='" +
                            step +
                            "'><div class='zfcsl-paginator-item-label'>" +
                            (step + 1) +
                            "</div></button>";
                }
                if (useSwiper)
                    paginatorHtml = paginatorHtml + "</div>";
                return paginatorHtml;
            });
            if (useSwiper) {
                searchResultObject.find(".zfcsl-paginator").each(function () {
                    var paginatorItemCount = $(this).find(".zfcsl-paginator-item").length;
                    const swiper = new Swiper("#" + $(this).attr("id"), {
                        modules: [Navigation, A11y],
                        allowTouchMove: true,
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                        spaceBetween: 0,
                        loop: false,
                        normalizeSlideIndex: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        navigation: {
                            enabled: paginatorItemCount > 5,
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        a11y: {
                            enabled: true,
                            nextSlideMessage: "Next slide",
                            prevSlideMessage: "Previous slide",
                            paginationBulletMessage: "Jump to slide {{index}}",
                            slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                            slideRole: "button",
                            itemRoleDescriptionMessage: "slide",
                        },
                        watchOverflow: true,
                    });
                    swiper.slideTo(currPage <= numPages - 4 ? currPage : numPages - 4);
                    if (zfcsaf.checkPaginationIncluded(paginations, "id", $(this).attr("id")) == false) {
                        paginations.push({
                            id: $(this).attr("id"),
                            paginationSwiper: swiper,
                        });
                    }
                });
                if (paginations.length < 2) {
                }
                else {
                    paginations[1].paginationSwiper.control =
                        paginations[0].paginationSwiper;
                    paginations[0].paginationSwiper.control =
                        paginations[1].paginationSwiper;
                }
            }
            else {
                searchResultObject.find(".zfcsl-paginator").slick({
                    rows: 0,
                    dots: false,
                    swipeToSlide: true,
                    slidesToScroll: 5,
                    infinite: false,
                    arrows: true,
                    slidesToShow: 5,
                });
                searchResultObject
                    .find(".zfcsl-paginator")
                    .slick("slickGoTo", currPage <= numPages - 4 ? currPage : numPages - 4);
            }
            searchResultObject.find(".zfcsl-paginator .zfcsl-paginator-item").each(function () {
                zfc.keyboardEnterToClick($(this));
            });
            searchResultObject
                .off("click", ".zfcsl-paginator .zfcsl-paginator-item")
                .on("click", ".zfcsl-paginator .zfcsl-paginator-item", function () {
                var _a;
                var item = $(this);
                searchResultObject
                    .find(".zfcsl-paginator-item.zfcsl-selected-item")
                    .removeClass("zfcsl-selected-item");
                item.addClass("zfcsl-selected-item");
                zfcsaf.controls[id].startPos =
                    item.data("page") * searchObject.data("shown");
                zfcsaf.search(id);
                zfcsaf.updateUrlParameters(id);
                $("html,body").animate({ scrollTop: (_a = searchObject.find(".zfcsaf-column-right").offset()) === null || _a === void 0 ? void 0 : _a.top }, "slow");
            });
        }
        else
            searchResultObject
                .find(".zfcsl_search_result_num span")
                .html(myData.data.length);
        if (searchResultObject.find(".zfcsl-paginator .swiper-slide").length == 0)
            searchResultObject.addClass("zfcsl-empty-pagination");
        searchResultObject.find(".handlebar_search_results").html(resultHTML);
        if (searchObject.data("type") == "press")
            zfcpc.init(true);
        searchResultObject
            .off("click", ".zfcec-table-results-table-column-header-title, .zfcsl_header_title")
            .on("click", ".zfcec-table-results-table-column-header-title, .zfcsl_header_title", function (i) {
            var sortVal = $(i.target).data("sort");
            if (sortVal == zfcsaf.controls[id].sortField) {
                if (zfcsaf.controls[id].sortOrder == "desc")
                    zfcsaf.controls[id].sortOrder = "asc";
                else
                    zfcsaf.controls[id].sortOrder = "desc";
            }
            else
                zfcsaf.controls[id].sortOrder = "asc";
            zfcsaf.controls[id].sortField = sortVal;
            zfcsaf.renderResults(id);
        });
        if (zfcsaf.controls[id].sortField != null) {
            if (zfcsaf.controls[id].sortOrder == "asc")
                searchResultObject
                    .find('div[data-sort="' + zfcsaf.controls[id].sortField + '"]')
                    .addClass("zfcui-icon-sort-icon-up")
                    .addClass("zfcui-icon");
            else
                searchResultObject
                    .find('div[data-sort="' + zfcsaf.controls[id].sortField + '"]')
                    .addClass("zfcui-icon-sort-icon-down")
                    .addClass("zfcui-icon");
        }
        zfctt.init();
        searchResultObject.find("[data-text-limit]").each(zfc.limitText);
    }
    static getUrlParameters(id) {
        var queries = {};
        if (document.location.search != "")
            $.each(document.location.search
                .replace(RegExp("%20", "g"), " ")
                .replace(RegExp("%27", "g"), "'")
                .replace(RegExp("%7C", "g"), "|")
                .substr(1)
                .split("&"), function (c, q) {
                var i = q.replace(RegExp("%26", "g"), "&").split("=");
                if (i.length > 1)
                    queries[i[0].toString()] = i[1].toString();
            });
        zfcsaf.urlParameters = queries;
        if (zfcsaf.urlParameters.hasOwnProperty("query")) {
            zfcsaf
                .findSearchControl(id)
                .val(decodeURI(zfcsaf.urlParameters["query"]
                .replace(RegExp("'", "g"), "")
                .replace(RegExp("%pnd;", "g"), "#")));
        }
        if (zfcsaf.urlParameters.hasOwnProperty("filterValues") &&
            zfcsaf.urlParameters["filterValues"] != "") {
            zfcsaf.urlParameters["filterValues"]
                .split("' ")
                .forEach(function (item) {
                var filterKeyValuesPair = item.split("|");
                $.each(filterKeyValuesPair, function (key, pair) {
                    var filterKey = pair.split(":")[0];
                    var filterValues = pair.split(":")[1].split(",");
                    zfcsaf.controls[id].filters[filterKey] = {};
                    $.each(filterValues, function (key, value) {
                        value = value
                            .replace(RegExp("'", "g"), "")
                            .replace(RegExp("%pnd;", "g"), "#");
                        value = value
                            .replace(RegExp("%C3%A4", "g"), "ä")
                            .replace(RegExp("%C3%B6", "g"), "ö")
                            .replace(RegExp("%C3%BC", "g"), "ü")
                            .replace(RegExp("%C3%9F", "g"), "ß");
                        value = value
                            .replace(RegExp("%C3%84", "g"), "Ä")
                            .replace(RegExp("%C3%96", "g"), "Ö")
                            .replace(RegExp("%C3%9C", "g"), "Ü");
                        zfcsaf.controls[id].filters[filterKey][value] = value;
                    });
                });
            });
        }
        if (zfcsaf.urlParameters.hasOwnProperty("start"))
            zfcsaf.controls[id].startPos = zfcsaf.urlParameters["start"];
        if (zfcsaf.findSearchObject(id).data("filter-html") &&
            Object.keys(zfcsaf.controls[id].filters).length === 0) {
            zfcsaf.controls[id].filters["content_type"] = {};
            zfcsaf.controls[id].filters["content_type"]["html"] = "html";
        }
    }
    static updateUrlParameters(id) {
        var searchObject = zfcsaf.findSearchObject(id);
        var url = window.location.href.split("?")[0];
        var urlParameters = "";
        var searchVal = zfcsaf.findSearchControl(id).val();
        if (searchVal == "")
            urlParameters = urlParameters + "query=";
        else
            urlParameters =
                urlParameters + "query=" + searchVal.replace(RegExp("#", "g"), "%pnd;");
        urlParameters = urlParameters + "&start=" + zfcsaf.controls[id].startPos;
        var filterValues = "";
        var filterPartialValues = "";
        var isLastSelectedFilterType = Object.keys(zfcsaf.controls[id].filters)[Object.keys(zfcsaf.controls[id].filters).length - 1];
        for (var filterKey in zfcsaf.controls[id].filters) {
            var isLastSelectedFilter = Object.keys(zfcsaf.controls[id].filters[filterKey])[Object.keys(zfcsaf.controls[id].filters[filterKey]).length - 1];
            if (Object.keys(zfcsaf.controls[id].filters[filterKey]).length != 0) {
                filterPartialValues = filterPartialValues + filterKey + ":";
                Object.keys(zfcsaf.controls[id].filters[filterKey]).forEach(function (key) {
                    if (key.replace(/["']/g, "") != isLastSelectedFilter.replace(/'/g, "")) {
                        key = key + ",";
                    }
                    key = key
                        .replace(RegExp("&", "g"), "%26")
                        .replace(RegExp("#", "g"), "%23");
                    key = key
                        .replace(RegExp("ä", "g"), "%C3%A4")
                        .replace(RegExp("ö", "g"), "%C3%B6")
                        .replace(RegExp("ü", "g"), "%C3%BC")
                        .replace(RegExp("ß", "g"), "%C3%9F");
                    key = key
                        .replace(RegExp("Ä", "g"), "%C3%84")
                        .replace(RegExp("Ö", "g"), "%C3%96")
                        .replace(RegExp("Ü", "g"), "%C3%9C");
                    filterPartialValues = filterPartialValues + key;
                });
                if (filterKey != isLastSelectedFilterType) {
                    filterValues = filterValues + filterPartialValues + "|";
                    filterPartialValues = "";
                }
                else {
                    filterValues = filterValues + filterPartialValues;
                }
            }
        }
        if (searchObject.find("input[data-value=" + zfTranslations.get("all") + "]:checked").length > 0)
            filterValues = "";
        filterValues =
            filterValues.charAt(filterValues.length - 1) == "|"
                ? filterValues.substring(0, filterValues.length - 1)
                : filterValues;
        if (filterValues != "") {
            urlParameters = urlParameters + "&filterValues=";
            urlParameters = urlParameters + filterValues.trim();
        }
        if (zfcsaf.urlParameters.hasOwnProperty("zfcsaf-json"))
            urlParameters =
                urlParameters + "&zfcsaf-json=" + zfcsaf.urlParameters["zfcsaf-json"];
        window.history.replaceState({}, document.title, url + "?" + urlParameters);
    }
    static mapJsonData(id, json_data, searchType) {
        var _a;
        var lang = (_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang.toLowerCase();
        var langPost = "_" + lang;
        json_data.forEach(function (item) {
            item["parent_id"] = id;
            for (var key in item) {
                if (key.includes(langPost))
                    item[key.replace(langPost, "")] =
                        item[key] instanceof Array
                            ? item[key][0]
                                .replace(RegExp("&amp;", "g"), "&")
                                .replace(RegExp("&#35;", "g"), "#")
                                .replace(RegExp("&#59;", "g"), ";")
                                .replace(RegExp("&#32;", "g"), " ")
                            : item[key]
                                .replace(RegExp("&amp;", "g"), "&")
                                .replace(RegExp("&#35;", "g"), "#")
                                .replace(RegExp("&#59;", "g"), ";")
                                .replace(RegExp("&#32;", "g"), " ");
            }
            if (item.highlights && typeof item.highlights === "object") {
                for (var key in item.highlights) {
                    var rawHighlight = item.highlights[key];
                    var highlightValue = rawHighlight instanceof Array ? rawHighlight.join(" ") : (rawHighlight || "");
                    item.highlights[key.replace(langPost, "")] = highlightValue
                        .replace(RegExp("&amp;", "g"), "&")
                        .replace(RegExp("&#59;", "g"), ";")
                        .replace(RegExp("&lt;", "g"), "<")
                        .replace(RegExp("&gt;", "g"), ">")
                        .replace(RegExp("&#x2F;", "g"), "/")
                        .replace(RegExp("&#35;", "g"), "#")
                        .replace(RegExp("&#32;", "g"), " ");
                }
            }
            else {
                item.highlights = {};
            }
            if (item.hasOwnProperty("start_date"))
                item["date"] = item["start_date"].split("T")[0];
            if (item.hasOwnProperty("meta"))
                item["meta"] = JSON.parse(item["meta"]);
            if (item.hasOwnProperty("images") && Array.isArray(item["images"]) && item["images"].length > 0) {
                item["image"] = item["images"][0].replace("~1", "");
                var imgTmp = [];
                item.images.forEach(function (image) {
                    imgTmp.push(image.replace("~1", ""));
                });
                item["images"] = imgTmp;
            }
            else {
                item["images"] = [];
            }
            if (!item.hasOwnProperty("image"))
                item["image"] = "";
            if (searchType == "press") {
                item["mainLink"] = item["url"];
                item["isPressPage"] =
                    ($("meta[name='sitePrefix']").attr("content") || "").indexOf("press") >= 0
                        ? true
                        : false;
                item["previewImg"] = item["image"];
                item["media_type"] = Array.isArray(item["media_type"]) && item["media_type"].length
                    ? item["media_type"][0]
                    : (item["media_type"] || "");
                item["typeText"] = item["media_type"]
                    ? zfTranslations.get("press." + item["media_type"].toLowerCase())
                    : "";
                if (zfcsaf.isPastDate(item["start_date"]) &&
                    (!item.hasOwnProperty("meta") || item["meta"].hide_date != true))
                    item["releaseDate"] = item["date"];
                item["topics"] = item["category_1"];
                item["subtopics"] = item["category_2"];
                item["tags"] = item["category_3"];
                item["moreInfo"] = zfTranslations.get("press.more_information");
                item["fs_id"] = item.id.split("_")[item.id.split("_").length - 1];
                if (item["media_type"] == "release") {
                    item["type"] = "release";
                    item["mediaType"] = item["media_type"];
                    item["onClick"] = "javascript:zfcpc.downloadPress('" + item.id + "')";
                }
                else if (item["media_type"] == "kit") {
                    item["type"] = "kit";
                    item["mediaType"] = item["media_type"];
                    item["onClick"] = "javascript:zfcpc.downloadPress('" + item.id + "')";
                }
                else {
                    item["type"] = "media";
                    item["mediaType"] = item["media_type"];
                    item["imageOrig"] = item["image"].replace("_3_2_748px", "_Dynamic");
                    item["downloadLink"] = item["imageOrig"];
                    if (item.hasOwnProperty("meta") &&
                        item.meta.hasOwnProperty("pdf_link"))
                        item["downloadLink"] = item.meta.pdf_link;
                }
            }
            else if (searchType == "product" && item.hasOwnProperty("category_1")) {
                item["category_1_formatted"] = zfUtils
                    .arrayRemoveDuplicates(item.category_1)
                    .join("|");
            }
            else if (searchType == "search") {
                if (item.highlights.hasOwnProperty("content")) {
                    if (item.content_type == "pdf")
                        item.highlights.content = "";
                    else
                        item.highlights.content = zfUtils.decodeHtml(item.highlights.content
                            .replace(item.highlights.title, "")
                            .replace(item.highlights.description, "")
                            .trim());
                }
            }
            else if (searchType == "certificate") {
                var divisions = "";
                var locations = "";
                if (item.hasOwnProperty("category_2")) {
                    for (var i = 0; i < item.category_2.length; i++) {
                        divisions = divisions + (i > 0 ? " / " : "") + item.category_2[i];
                    }
                }
                item["divisions"] = divisions;
                if (item.hasOwnProperty("category_3")) {
                    for (var i = 0; i < item.category_3.length; i++) {
                        locations =
                            locations +
                                (i > 0 ? " / " : "") +
                                item.category_3[i] +
                                " - " +
                                item.category_4[i];
                    }
                }
                item["locations"] = locations;
            }
            else if (searchType == "supplier_board") {
                var cities = "";
                if (item.hasOwnProperty("category_3")) {
                    for (var i = 0; i < item.category_3.length; i++) {
                        cities = cities + (i > 0 ? " / " : "") + item.category_3[i];
                    }
                }
                item["cities"] = cities;
                var countries = "";
                if (item.hasOwnProperty("category_4")) {
                    for (var i = 0; i < item.category_4.length; i++) {
                        countries = countries + (i > 0 ? " / " : "") + item.category_4[i];
                    }
                }
                item["countries"] = countries;
            }
            else if (searchType == "event") {
                var locations = [];
                if (item.hasOwnProperty("category_1")) {
                    item.category_1 =
                        zfTranslations.get(item.category_1[0]) == ""
                            ? item.category_1[0]
                            : zfTranslations.get(item.category_1[0]);
                }
                if (item.hasOwnProperty("category_2")) {
                    for (var i = 0; i < item.category_2.length; i++) {
                        locations.push(item.category_2[i] + " - " + item.category_3[i]);
                    }
                }
                item["locations"] = locations;
                item["location"] = locations.join(" | ");
                if (item.hasOwnProperty("start_date"))
                    item["start_date"] = item["start_date"].split("T")[0];
                if (item.hasOwnProperty("end_date"))
                    item["end_date"] = item["end_date"].split("T")[0];
            }
            else if (searchType == "jobboard") {
                item["id"] = item["id"].split("_")[1];
            }
        });
        return json_data;
    }
    static setDataFromTag(id) {
        var searchObject = zfcsaf.findSearchObject(id);
        if (searchObject.data("fields") != undefined) {
            zfcsaf.controls[id].fields = searchObject.data("fields");
        }
        if (searchObject.data("sortfields") != undefined)
            zfcsaf.controls[id].sortFields = searchObject.data("sortfields");
        if (searchObject.data("sortfield") != undefined)
            zfcsaf.controls[id].sortField = searchObject.data("sortfield");
    }
    static getFilters(id, fieldName) {
        var _a, _b;
        var searchObject = zfcsaf.findSearchObject(id);
        var filterValues = "";
        if (searchObject.data("days-before") != undefined ||
            searchObject.data("days-after") != undefined) {
            var start_date = "1900-01-01T00:00:00Z";
            var end_date = "2999-12-31T23:59:59Z";
            if (searchObject.data("days-before") != undefined)
                start_date = zfcsaf.addDaysToIsoUtc(searchObject.data("days-before"));
            if (searchObject.data("days-after") != undefined)
                end_date = zfcsaf.addDaysToIsoUtc(searchObject.data("days-after"));
            filterValues = "start_date:[" + start_date + " TO " + end_date + "] ";
        }
        var filterPartialValues = "";
        var skip = false;
        (_a = zfcsaf.controls[id].fields) === null || _a === void 0 ? void 0 : _a.forEach(function (field) {
            var partialSelectedFilterValues = "";
            if (fieldName == field.id && fieldName != "false")
                skip = true;
            if (!skip || field.display == "false") {
                if (zfcsaf.controls[id].filters.hasOwnProperty(field.label) &&
                    fieldName != "false") {
                    if (field.id == "start_date" &&
                        Object.keys(zfcsaf.controls[id].filters[field.label]).length > 0)
                        filterValues =
                            field.id +
                                ":" +
                                Object.keys(zfcsaf.controls[id].filters[field.label])[0] +
                                " ";
                    else {
                        Object.keys(zfcsaf.controls[id].filters[field.label]).forEach(function (key) {
                            key =
                                field.id +
                                    ":(" +
                                    key
                                        .replace(RegExp("\\s", "g"), "*")
                                        .replace(RegExp("\\(", "g"), "*")
                                        .replace(RegExp("\\)", "g"), "*") +
                                    ") ";
                            key = key
                                .replace(RegExp("&", "g"), "%26")
                                .replace(RegExp("#", "g"), "%23")
                                .replace(RegExp("ä", "g"), "%C3%A4")
                                .replace(RegExp("ö", "g"), "%C3%B6")
                                .replace(RegExp("ü", "g"), "%C3%BC")
                                .replace(RegExp("ß", "g"), "%C3%9F")
                                .replace(RegExp("Ä", "g"), "%C3%84")
                                .replace(RegExp("Ö", "g"), "%C3%96")
                                .replace(RegExp("Ü", "g"), "%C3%9C");
                            if (partialSelectedFilterValues != "")
                                partialSelectedFilterValues += " OR ";
                            partialSelectedFilterValues = partialSelectedFilterValues + key;
                        });
                        if (Object.keys(zfcsaf.controls[id].filters[field.label]).length > 1) {
                            filterPartialValues =
                                filterPartialValues + "( " + partialSelectedFilterValues + ")";
                            partialSelectedFilterValues = "";
                        }
                        else {
                            filterPartialValues =
                                filterPartialValues +
                                    (filterPartialValues == ""
                                        ? partialSelectedFilterValues
                                        : partialSelectedFilterValues == ""
                                            ? ""
                                            : " AND " + partialSelectedFilterValues);
                        }
                    }
                }
            }
        });
        if (searchObject.find("input[data-value=" + zfTranslations.get("all") + "]:checked").length > 0)
            filterPartialValues = "";
        if (filterValues.match(/\(or/g) != null &&
            (((_b = filterValues.match(/\(or/g)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 1) {
            filterValues =
                filterValues +
                    (filterValues == "" ? "(" : " AND (") +
                    filterPartialValues +
                    ")";
        }
        else {
            filterValues = filterValues + filterPartialValues;
        }
        if (searchObject.data("prefilter") != "")
            filterValues =
                filterValues +
                    (filterValues == "" ? "(" : " AND (") +
                    searchObject
                        .data("prefilter")
                        .replace(RegExp("&", "g"), "%26")
                        .replace(RegExp("#", "g"), "%23") +
                    ") ";
        if (searchObject.data("type") == "product")
            filterValues =
                filterValues +
                    (filterValues == "" ? "content_type:html" : " AND content_type:html");
        if (filterValues != "")
            filterValues = "&filterValues=" + filterValues;
        return filterValues;
    }
    static search(id, getFacetData) {
        var _a;
        var searchObject = zfcsaf.findSearchObject(id);
        var searchResultObject = searchObject.find(".zfcsl_search_result");
        var query = "matchall";
        var searchVal = zfcsaf.findSearchControl(id).val().toLowerCase();
        if (searchVal != "")
            query = encodeURI(searchVal.replace(RegExp("#", "g"), "%pnd;"));
        if (searchVal != zfcsaf.controls[id].currQuery || getFacetData == true) {
            zfcsaf.controls[id].currQuery = zfcsaf
                .findSearchControl(id)
                .val()
                .toLowerCase();
            if (searchObject.data("hide-filters") != "yes") {
                var fields = zfcsaf.controls[id].fields || [];
                var firstField = fields[0];
                if (firstField) {
                    zfcsaf.getFacetData(id, firstField.id);
                }
            }
        }
        var searchScope = searchObject.data("scope");
        if (searchObject.data("type") == "article")
            searchScope = "default";
        var searchUrl = zfcsaf.searchTargetUrl + "?query=" + query;
        searchUrl = searchUrl + zfcsaf.getFilters(id, "true");
        searchUrl = searchUrl + "&region=" + zfcsr.selectedRegion;
        searchUrl =
            searchUrl +
                "&language=" +
                ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang.toUpperCase());
        searchUrl = searchUrl + "&scope=" + searchScope;
        searchUrl = searchUrl + "&queryType=" + searchObject.data("type");
        searchUrl = searchUrl + "&size=" + searchObject.data("shown");
        searchUrl = searchUrl + "&start=" + zfcsaf.controls[id].startPos;
        if (searchObject.data("sortfield") != undefined &&
            searchObject.data("sortfield") != "default")
            searchUrl = searchUrl + "&sort=" + searchObject.data("sortfield");
        if (zfcsaf.urlParameters.hasOwnProperty("zfcsaf-json"))
            searchUrl = zfcsaf.urlParameters["zfcsaf-json"];
        zfUtils.displaySpinner();
        $.ajax({
            url: searchUrl,
            dataType: "json",
        })
            .done(function (json_data_tmp) {
            var json_data = json_data_tmp.body;
            json_data.name ? zfccg.setTitle(json_data.name) : null;
            zfcsaf.controls[id].jsonDataSize = json_data.hits.found;
            zfcsaf.controls[id].jsonData = zfcsaf.mapJsonData(id, json_data.hits.hit, searchObject.data("type"));
            zfcsaf.renderResults(id);
            if (zfcsaf.urlParameters["event"] != undefined)
                zfcsaf.openModal(searchResultObject.find(".zfcec-modal-trigger")[0], zfcsaf.urlParameters["event"]);
            if (zfcsaf.urlParameters["modalField"] != undefined &&
                zfcsaf.urlParameters["modalValue"] != undefined)
                zfcsaf.openModal(searchResultObject.find(".zfcec-modal-trigger")[0], zfcsaf.urlParameters["modalValue"], zfcsaf.urlParameters["modalField"]);
            zfUtils.hideSpinner();
        })
            .fail(function (jqXHR, textStatus) {
            console.log("zfcsaf.search ajax call failed: " + textStatus);
            zfUtils.hideSpinner();
        });
    }
    static getFacetData(id, fieldName, callback) {
        var _a;
        var searchObject = zfcsaf.findSearchObject(id);
        var query = "matchall";
        var searchVal = zfcsaf.findSearchControl(id).val().toLowerCase();
        if (searchVal != "")
            query = encodeURI(searchVal.replace(RegExp("#", "g"), "%pnd;"));
        var searchScope = searchObject.data("scope");
        if (searchObject.data("type") == "article")
            searchScope = "default";
        if (searchObject.data("prefilter") != "") {
            if (searchObject.data("prefilter").indexOf(fieldName + ":") != -1) {
                zfcsaf.controls[id].prefilter[fieldName] = {};
                searchObject
                    .data("prefilter")
                    .split(" OR ")
                    .forEach(function (value) {
                    if (value.indexOf(fieldName) != -1) {
                        var pfv = value.split(":(")[1].replace(")", "");
                        zfcsaf.controls[id].prefilter[fieldName][pfv] = pfv;
                    }
                });
            }
        }
        (_a = zfcsaf.controls[id].fields) === null || _a === void 0 ? void 0 : _a.forEach(function (field, index) {
            var _a;
            if (fieldName == field.id) {
                var searchUrl = zfcsaf.searchTargetUrl + "?query=" + query;
                searchUrl = searchUrl + zfcsaf.getFilters(id, field.id);
                searchUrl = searchUrl + "&region=" + zfcsr.selectedRegion;
                searchUrl =
                    searchUrl +
                        "&language=" +
                        ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang.toUpperCase());
                searchUrl = searchUrl + "&scope=" + searchScope;
                searchUrl = searchUrl + "&queryType=" + searchObject.data("type");
                searchUrl = searchUrl + "&size=0&start=0";
                zfUtils.displaySpinner();
                $.ajax({
                    url: searchUrl,
                    dataType: "json",
                })
                    .done(function (json_data_tmp) {
                    var _a;
                    var json_data = json_data_tmp.body;
                    var matchesFieldName = false;
                    (_a = zfcsaf.controls[id].fields) === null || _a === void 0 ? void 0 : _a.forEach(function (data, index) {
                        if (fieldName == data.id || matchesFieldName) {
                            if (fieldName == data.id)
                                matchesFieldName = true;
                            if (json_data.facets[data.id] != undefined) {
                                if (zfcsaf.controls[id].prefilter.hasOwnProperty(data.id))
                                    json_data.facets[data.id].buckets = json_data.facets[data.id].buckets.filter(function (value) {
                                        return zfcsaf.controls[id].prefilter[data.id].hasOwnProperty(value.value);
                                    });
                                zfcsaf.controls[id]["facets"][data.id] =
                                    json_data.facets[data.id];
                                zfcsaf.controls[id]["facets"][data.id].buckets =
                                    zfcsaf.controls[id]["facets"][data.id].buckets.sort(function (a, b) {
                                        return a.value.localeCompare(b.value);
                                    });
                                zfcsaf.controls[id]["facets"][data.id].buckets.unshift({
                                    value: zfTranslations.get("all"),
                                    count: json_data.hits.found,
                                });
                            }
                        }
                    });
                    if (zfcsaf.controls[id].facets.hasOwnProperty("start_date") &&
                        zfcsaf.controls[id].facets.start_date.hasOwnProperty("buckets") &&
                        zfcsaf.controls[id].facets.start_date.buckets.length > 0) {
                        zfcsaf.controls[id].facets.start_date.buckets = [];
                        zfcsaf.controls[id].facets.start_date.buckets.push({
                            value: zfTranslations.get("all"),
                            count: "",
                        });
                        zfcsaf.controls[id].facets.start_date.buckets.push({
                            label: zfTranslations.get("4_weeks"),
                            value: "4_weeks",
                            count: "",
                        });
                        zfcsaf.controls[id].facets.start_date.buckets.push({
                            label: zfTranslations.get("3_months"),
                            value: "3_months",
                            count: "",
                        });
                        zfcsaf.controls[id].facets.start_date.buckets.push({
                            label: zfTranslations.get("1_year"),
                            value: "1_year",
                            count: "",
                        });
                    }
                    zfcsaf.updateChecklists(id, field.id);
                    zfcsaf.activeFiltersDisplay(id);
                    zfUtils.hideSpinner();
                    if (callback != undefined)
                        callback();
                })
                    .fail(function (jqXHR, textStatus) {
                    console.log("zfcsaf.search ajax call failed getFacetData: " + textStatus);
                });
            }
        });
    }
    static autocomplete(scope, autocompleteKey, value, resultCount, requestVersion, shouldOpenDropdown = true) {
        var _a;
        var inputElement = zfcsaf.autocompleteInputs[autocompleteKey];
        if (!inputElement)
            return;
        zfcsaf.registerAutocompleteInput(autocompleteKey, inputElement);
        var lang = (_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang.toLowerCase();
        var searchUrl = zfcsaf.searchTargetUrl + "?query=" + encodeURIComponent(value) + "&region=&language=" + (lang === null || lang === void 0 ? void 0 : lang.toLowerCase()) + "&scope=" + scope + "&queryType=autocomplete&sort=instances&size=" + resultCount + "&start=0";
        $.ajax({
            url: searchUrl,
            dataType: "json",
        })
            .done(function (json_data_tmp) {
            var _a, _b;
            if (typeof requestVersion !== "undefined" &&
                requestVersion !== zfcsaf.autocompleteRequestVersion[autocompleteKey])
                return;
            var autocomplete = zfcsaf.autocompleteInstances[autocompleteKey];
            if (!autocomplete)
                return;
            var items = [];
            var dedupe = {};
            var hits = ((_b = (_a = json_data_tmp === null || json_data_tmp === void 0 ? void 0 : json_data_tmp.body) === null || _a === void 0 ? void 0 : _a.hits) === null || _b === void 0 ? void 0 : _b.hit) || [];
            hits.forEach(function (item) {
                var label = String((item === null || item === void 0 ? void 0 : item["title_" + lang]) ||
                    (item === null || item === void 0 ? void 0 : item.title_en) ||
                    (item === null || item === void 0 ? void 0 : item.title) ||
                    "").trim();
                if (label.length > 0 && !dedupe[label]) {
                    dedupe[label] = true;
                    items.push(label);
                }
            });
            autocomplete.list = items;
            if (items.length == 0) {
                if (typeof autocomplete.close === "function")
                    autocomplete.close();
                return;
            }
            if (shouldOpenDropdown && typeof autocomplete.evaluate === "function")
                autocomplete.evaluate();
        });
    }
    static init() {
        try {
            if (!zfcsaf.hasTargets())
                return;
            if (zfcsaf.initialized)
                return;
            zfcsr.registerCallback(".zfcsaf-search-filter-wrapper", function (that) {
                zfcsaf.search(zfcsaf.findMainId(that), true);
            });
            for (var i in zfTranslations.translations) {
                zfcsaf.translations[i] = zfTranslations.get(i);
            }
            $(".zfcsaf-search-filter-wrapper").each(function () {
                zfUtils.displaySpinner();
                var wrapper = $(this);
                var id = wrapper.attr("id");
                if (id != undefined) {
                    var searchObject = zfcsaf.findSearchObject(id);
                    zfcsaf.controls[id] = {
                        startPos: 0,
                        jsonResults: {},
                        filters: {},
                        facets: {},
                        getFacetCount: 0,
                        prefilter: {},
                    };
                    zfcsaf.controls[id].resetFilterBtn = searchObject.find(".zfcsaf-search-tool-meta-reset");
                    zfcsaf.setDataFromTag(id);
                    zfcsaf.getUrlParameters(id);
                    if (searchObject.data("hide-search") == "yes")
                        searchObject.find(".zfccf-search-tool-search-row").hide();
                    zfcsaf.search(id);
                    zfcsaf.prepareControls(id);
                    var searchInput = searchObject
                        .find('.zfccf-certificate-form-input input[type="text"]')
                        .get(0);
                    zfcsaf.registerAutocompleteInput("zfcsaf-datalist-" + id, searchInput);
                    zfcsaf.scheduleAutocomplete(searchObject.data("scope"), "zfcsaf-datalist-" + id, 'matchall', 15, true);
                    zfUtils.hideSpinner();
                }
            });
            zfcsaf.initialized = true;
        }
        catch (err) {
            console.log("Initalization failed: zfcsaf.init() " + err.message);
            zfUtils.hideSpinner();
        }
    }
}
zfcsaf.searchTargetUrl = "/api/solr/getSearch";
zfcsaf.translations = [];
zfcsaf.initialized = false;
zfcsaf.autocompleteDebounceTimers = {};
zfcsaf.autocompleteRequestVersion = {};
zfcsaf.autocompleteInstances = {};
zfcsaf.autocompleteInputs = {};
zfcsaf.autocompleteDebounceMs = 200;
zfcsaf.controls = {};
